var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfodifetti3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_20600",
    "data-name": "Raggruppa 20600",
    transform: "translate(-987 1960)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_10947",
    "data-name": "Rettangolo 10947",
    width: 23,
    height: 23,
    rx: 3,
    transform: "translate(987 -1960)",
    fill: "#3260ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-bulb",
    "data-name": "Icon ionic-md-bulb",
    d: "M10.678,17.255a.7.7,0,0,0,.7.7h3.084a.7.7,0,0,0,.7-.7v-.631H10.678ZM12.921,4.5A4.874,4.874,0,0,0,7.875,9.2a4.634,4.634,0,0,0,2.152,3.876v1.521a.7.7,0,0,0,.722.673H15.09a.7.7,0,0,0,.722-.673V13.071A4.629,4.629,0,0,0,17.967,9.2,4.874,4.874,0,0,0,12.921,4.5Z",
    transform: "translate(985.125 -1959.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfodifetti3);
export default __webpack_public_path__ + "static/media/infodifetti3.70d88d308730aa1ad81fb02675fea530.svg";
export { ForwardRef as ReactComponent };